<p-drawer
  id="mobileAppNavSideBar"
  [(visible)]="turnOnMobileAppNavigation"
  [modal]="false"
  [blockScroll]="true"
  [showCloseIcon]="false"
  [appendTo]="'.app-side-nav'"
  (onShow)="onMobileAppNavShow()"
  (onHide)="onMobileAppNavHide()"
  data-testid="shared-mobile-nav-sidebar"
>
  <app-navigation [is-large-screen]="false"></app-navigation>
</p-drawer>
